import React, {useEffect, useState} from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportCard from "../../../../components/reports/report-card.jsx";
import ReportUtils from "../../../../utils/report-utils.js";
import SubmissionsModal from "./submissions-modal.jsx";

const SHEET_NAME = "Análise de formulários";

const buildSections = (structure = [], fields = []) => {
    const sectionByField = new Map();
    let current = null;

    structure?.forEach(item => {
        if (item.type === "subtitle") {
            current = item.label || null;
            return;
        }

        sectionByField.set(item.id, current);
    });

    const sections = [];

    fields.forEach(field => {
        const title = sectionByField.get(field.id) ?? null;
        const last = sections[sections.length - 1];

        if (last && last.title === title) last.fields.push(field);
        else sections.push({title, fields: [field]});
    });

    return sections;
};

const FieldRows = ({field, onSelectValue}) => {
    if (!field.values.length) {
        return (
            <tr className="table-break-word">
                <td className="align-top font-semibold">{field.label}</td>
                <td colSpan={2}>Não informado</td>
            </tr>
        );
    }

    return field.values.map(({value, total, pdf_id}, index) => {
        const borderClass = index === field.values.length - 1 ? "" : "border-b-0!";

        return (
            <tr className="table-break-word" key={`${field.id}-${index}`}>
                {
                    index === 0 &&
                    <td rowSpan={field.values.length} className="align-top font-semibold">
                        {field.label}
                    </td>
                }
                <td className={borderClass}>{value}</td>
                <td className={`text-center font-semibold whitespace-nowrap ${borderClass}`}>
                    <button
                        type="button"
                        title={"Ver os formulários com esta resposta"}
                        className="cursor-pointer hover:text-[#1588F3] hover:underline print:text-inherit print:!no-underline"
                        onClick={() => onSelectValue({fieldLabel: field.label, value, total, pdfIds: pdf_id ?? []})}
                    >
                        {total}
                    </button>
                </td>
            </tr>
        );
    });
};

const Content = ({reportData, data, entity, title, structure, templateId, printComponentRef, setIsLoading}) => {
    const [selected, setSelected] = useState(null);

    const fields = reportData?.fields ?? [];
    const sections = buildSections(structure, fields);

    useEffect(() => {
        if (!reportData) return;

        ReportUtils.withoutContentReadjust();

        const values = sections.flatMap(({title: sectionTitle, fields: sectionFields}) =>
            sectionFields.flatMap(({label, values: fieldValues}) =>
                fieldValues.map(({value, total}) => [sectionTitle ?? "", label, value, total])
            )
        );

        ReportUtils.createExportableTable(["Seção", "Campo", "Valor", "Total"], values, SHEET_NAME);
    }, [reportData]);

    return (
        <>
            {reportData && data > 0 && (
                <PrintTemplate
                    entity={entity}
                    title={title}
                    ref={printComponentRef}
                    setIsPrinting={setIsLoading}
                >
                    <div id="filters-print" className="transform !-translate-y-[8.5px]" />
                    <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full" />

                    <div className="w-full mt-[25px] print:mt-0">
                        <div className="grid grid-cols-2">
                            <ReportCard title="Formulários analisados" value={data}/>
                            <ReportCard title="Campos analisados" value={fields.length}/>
                        </div>

                        <div className="chart-divisor"/>

                        <table
                            id="generic-form-analyse-data"
                            className="table report-table"
                            sheet-name={SHEET_NAME}
                        >
                            <thead className="thead-background">
                                <tr className="bg-[#f6f6f6] text-left">
                                    <th className="w-[35%]">Campo</th>
                                    <th className="w-[55%]">Valor</th>
                                    <th className="w-[10%] text-center">Total</th>
                                </tr>
                            </thead>

                            <tbody className="bg-white">
                                {sections.map((section, index) => (
                                    <React.Fragment key={`${section.title ?? "geral"}-${index}`}>
                                        {
                                            section.title &&
                                            <tr>
                                                <td colSpan={3} className="font-semibold! print:break-after-avoid!">
                                                    {section.title}
                                                </td>
                                            </tr>
                                        }

                                        {section.fields.map(field => (
                                            <FieldRows key={field.id} field={field} onSelectValue={setSelected}/>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>

                        <div id="chart-tables"/>
                    </div>
                </PrintTemplate>
            )}

            <SubmissionsModal
                open={!!selected}
                setOpen={() => setSelected(null)}
                templateId={templateId}
                selected={selected}
            />
        </>
    );
};

export default Content;
